// extracted by mini-css-extract-plugin
export default {"cell":"TableDataCell_cell__+EWdy","cellSmall":"TableDataCell_cellSmall__vc7oY","cellAlignRight":"TableDataCell_cellAlignRight__nDtjd"};